import React, { useRef, useState } from 'react';
import s from './PromptBlock.module.css';
import { useSelector } from 'react-redux';
import {
    selectCurrentProject,
    selectIsSearchingReferences,
    selectReferences,
} from '../../../../store/selectors/projectSelectors';
import Button from '../../../../shared/ui/button/Button';
import { useAppDispatch } from '../../../../store/store';
import IconSearch from '../../../../shared/ui/icons/IconSearch';
import IconClipboard from '../../../../shared/ui/icons/IconClipboard';
import IconCheck from '../../../../shared/ui/icons/IconCheck';
import { searchReference } from '../../../../shared/api/textProjectApi';

const ReferencesBlock = () => {
    const dispatch = useAppDispatch();
    const currentProject = useSelector(selectCurrentProject);
    const reference = useSelector(selectReferences);
    const isLoading = useSelector(selectIsSearchingReferences);
    const [copiedId, setCopiedId] = useState<number | null>(null);
    const debounceRef = useRef<NodeJS.Timeout | null>(null);

    const handleSearch = async () => {
        if (!currentProject?.id) return;
        await dispatch(searchReference({ projectId: currentProject.id }));
    };

    const handleCopyReference = (id: number, url: string) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        navigator.clipboard.writeText(url);
        setCopiedId(id);

        debounceRef.current = setTimeout(() => {
            setCopiedId(null);
        }, 1000);
    };

    return (
        <div className={s.container}>
            <div className={s.block_container}>
                <div className={s.header_container}>
                    <p className={s.bold_header}>
                        Here are a few references we found based on your content
                    </p>
                    <p className={s.text}>Follow or add the references to your content</p>
                </div>

                <div className={s.references_container}>
                    {reference?.map((ref) => (
                        <div key={ref.id} className={s.reference_item}>
                            <a
                                className={s.reference_link}
                                href={ref.url}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {ref.url}
                            </a>
                            <button
                                onClick={() => handleCopyReference(ref.id, ref.url)}
                                className={s.copy_button}
                                title="Copy reference"
                            >
                                {copiedId === ref.id ? (
                                    <IconCheck width={12} height={12} />
                                ) : (
                                    <IconClipboard width={12} height={12} />
                                )}
                            </button>
                        </div>
                    ))}
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Button
                        text="Search"
                        state={isLoading ? 'loading' : 'enabled'}
                        onClick={handleSearch}
                        icon={<IconSearch width={16} height={16} />}
                        iconPosition="left"
                        style={{
                            backgroundColor: '#FFDD35',
                            color: '#000',
                            width: 'auto',
                            minWidth: '120px',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReferencesBlock;
